import { DEFAULT_LOCALE, LOCALES } from "app/language/model"
import { CURRENCIES } from "currency/model"
import { DISTANCE_UNITS } from "form/map/model"
import { UI_THEMES } from "ui/model"
import {
  EMPTY_TOKEN_EXPIRATION_VALUE,
  EMPTY_TOKEN_VALUE,
  EMPTY_USER_ID,
  IUserInfo,
  IUserSignUpState,
  IUserState,
  SIGNUP_STATUS,
  SIGNUP_WIZARD_STEPS
} from "user/model"

export function getDefaultUserState(): IUserState {
  return {
    ...getEmptyUserInfo(),
    isLoggingIn: false,
    isReLoginPopupOpened: false,
    signup: getDefaultSignUpWizardState()
  }
}

export const getDefaultSignUpWizardState = (locale?: LOCALES): IUserSignUpState => ({
  step: SIGNUP_WIZARD_STEPS.FIRST,
  status: SIGNUP_STATUS.IN_PROGRESS,
  userForm: {
    data: {
      email: "",
      firstname: "",
      lastname: "",
      language_id: locale || DEFAULT_LOCALE,
      phone: "",
      password1: "",
      password2: ""
    },
    isValid: false,
    errors: {}
  },
  agencyForm: {
    data: {
      name: "",
      language_id: locale || DEFAULT_LOCALE,
      currency_id: getCurrencyFromBrowserLocale(),
      country: "",
      state: ""
    },
    isValid: false,
    errors: {}
  }
})

export function getEmptyUserInfo(): IUserInfo {
  return {
    user: {
      id: EMPTY_USER_ID,
      agency_id: null,
      demo_mode: false,
      account_manager_id: null,
      account_manager_id2: null,
      analyst_id: null,
      lookup_countries_id: null,
      lookup_states_id: null,
      active: false,
      email: "",
      monitoring_emails: null,
      crypted_password: null,
      salt: "",
      title: null,
      firstname: null,
      lastname: null,
      birth_year: null,
      phone: null,
      address_1: null,
      address_2: null,
      city: null,
      postalcode: null,
      activation_code: null,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      delivery_fee_active: false,
      show_contracts: false,
      has_sales_access: false,
      sales_revenue_ratio: null,
      custom_revenue_ratio: null,
      company_name: null,
      payments_to: null,
      fax: null,
      fixed_cpm: null,
      language_id: "",
      order_prefix: null,
      gst_number: null,
      pst_number: null,
      show_zone_label: false,
      screen_id_prefix: null,
      site_name_prefix: null,
      source: null,
      notes: null,
      currency_id: "",
      time_zone_id: "",
      ui_settings: {
        theme: UI_THEMES.LIGHT,
        distance_unit: DISTANCE_UNITS.MILES
      },
      avatar: null,
      dsp_id: null
    },
    token: EMPTY_TOKEN_VALUE,
    tokenExpirationDateTime: EMPTY_TOKEN_EXPIRATION_VALUE,
    permissions: [],
    picture: ""
  }
}

const getCurrencyFromBrowserLocale = (): CURRENCIES => {
  // ex: 'Europe/Paris'
  const origin = Intl.DateTimeFormat().resolvedOptions().timeZone.split("/")[0].toLowerCase()
  switch (origin) {
    case "europe": {
      return CURRENCIES.EUR
    }
    case "canada": {
      return CURRENCIES.CAD
    }
    default: {
      return CURRENCIES.USD
    }
  }
}
